import { useRef, useState, useEffect } from "react";
import clsx from "clsx";
import { Text } from "components/common";
import useOnClickOutside from "hooks";
import classes from "./Dropdown.module.css";

const Dropdown = ({
  children,
  isActive,
  items,
  selectedValue,
  onSelect,
  setIsActive,
  v2,
  parentRef, // Optional parent container ref
}) => {
  const ref = useRef(null);
  const dropdownRef = useRef(null);
  const [dropdownPosition, setDropdownPosition] = useState("bottom");

  // Close dropdown when clicking outside
  useOnClickOutside(ref, () => setIsActive(false));

  useEffect(() => {
    if (isActive && ref?.current && dropdownRef?.current) {
      const triggerRect = ref.current.getBoundingClientRect();
      const dropdownHeight = dropdownRef.current.offsetHeight;

      // Calculate available space based on parent or window
      let spaceBelow, spaceAbove;

      if (parentRef?.current) {
        // Use parent container for space calculation
        const parentRect = parentRef.current.getBoundingClientRect();
        spaceBelow = parentRect.bottom - triggerRect.bottom;
        spaceAbove = triggerRect.top - parentRect.top;
      } else {
        // Use window for space calculation
        spaceBelow = window.innerHeight - triggerRect.bottom;
        spaceAbove = triggerRect.top;
      }

      // Determine dropdown position
      if (spaceBelow < dropdownHeight && spaceAbove > dropdownHeight) {
        setDropdownPosition("top");
      } else {
        setDropdownPosition("bottom");
      }
    }
  }, [isActive, parentRef]);

  return (
    <div className={clsx(classes.dropdown, v2 && classes.wFull)} ref={ref}>
      <div className={classes.labelContainer}>{children}</div>
      <div
        ref={dropdownRef}
        className={clsx(
          classes.dropdownMain,
          isActive && classes.active,
          dropdownPosition === "top" && classes.above,
          v2 && classes.v2
        )}
        role="listbox"
        aria-expanded={isActive}
      >
        <div className={clsx(classes.list, "overflow")}>
          {items?.map((item, idx) => (
            <div
              key={`item-${idx}`}
              className={clsx(
                classes.listItem,
                selectedValue === item && classes.active
              )}
              onClick={() => {
                setIsActive(false);
                onSelect(item);
              }}
            >
              {v2 ? (
                <>
                  <img
                    src={item.logo}
                    alt={item.name}
                    className={classes.logo}
                  />
                  <Text medium>{item.name}</Text>
                </>
              ) : (
                <Text medium>{item}</Text>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Dropdown;
